/**
 * Given the labels for a template and one of its copies, determines the
 * copy's prefix and suffix
 */
function get (rollupTreeGroupLabel, copyLabel) {
	var tstart = copyLabel.indexOf(rollupTreeGroupLabel)

	var tend = null
	if (tstart != -1) {
		tend = tstart + rollupTreeGroupLabel.length
	}

	return {
		prefix: tstart === -1 ? '' : copyLabel.substring(0, tstart),
		suffix: tend === null ? '' : copyLabel.substring(tend)
	}
}

/**
 * Given a template's label and a copy's prefix and suffix, determines
 * the full label for the copy
 */
function apply (rollupTreeGroupLabel, prefix, suffix) {
	return (prefix ? prefix : '') + rollupTreeGroupLabel + (suffix ? suffix : '')
}


export default {
	get: get,
	apply: apply
}
